module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_lymphoid_white_blood_cells_4-a27ea0897585631903fae45b13fae2c5.jpg";